import './Spinner.css';

export const Spinner = () => (
  <div className="spinner">
    <span className="loader"></span>
  </div>
);
